import { render, staticRenderFns } from "./AdEditComponent.vue?vue&type=template&id=67a5b406&scoped=true&"
import script from "./AdEditComponent.vue?vue&type=script&lang=js&"
export * from "./AdEditComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdEditComponent.vue?vue&type=style&index=0&id=67a5b406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5b406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VFileInput,VTextField})
